module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_vm._v("“I Did Not Kill Armstrong”: The War of Wills in the Early Days of Radio")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("January 31, 1954")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("River House Apartments, 13th Floor")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("East 52nd Street, New York City")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Numbers don’t lie,")]), _vm._v(" Armstrong thought. That fact had always been a cold comfort, even through the worst of times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the quiet of his room he let his mind tick through the equations once again. The results were still the same: There was a high probability that his remains would be smashed beyond recognition by his impact with the sidewalk far below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d done the math on his impending suicide because he was, above all else, an engineer. But there were still many variables to consider: the winter breezes gusting over the East River, updrafts and downdrafts flowing between the tall buildings, humidity, air density, and drag coefficients—even the courage with which he would take his fatal step from the ledge. To a layman, these concerns might seem minor compared to the most obvious unknown that he faced: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("What kinder world, if any, might await him on the other side?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His mind turned back to the matters at hand.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Armstrong knew that when it was all over—after the police and the coroner arrived—a quick identification of his body might ease the burden of his loved ones. So, in the likely event that his features would be destroyed by trauma, he had dressed himself in the usual careful fashion that his neighbors would immediately recognize.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He stood before the mirror, straightened his tie, and saw himself as he would soon be discovered: an evening overcoat, a wool scarf, gloves, and his favorite walking hat. All was as it should be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the corner of the desk lay his last words. The pages were placed under a paperweight to protect them from the winds that might sweep in upon his exit through the open window. He’d intended to leave only a brief goodbye, but once he’d begun, writing a lifetime of memories had passed before his eyes. Many things long denied had finally become clear to him, but in the end, none were more certain than this: Every one of his inventions, all of his achievements, and everything he’d once dreamed for the world would soon be buried and forgotten—right along with his name.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("His signature was the last detail to consider. Most acquaintances addressed him only by his middle name of Howard, while old friends often called him "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("the Major")]), _vm._v(" in recognition of his permanent army rank and his many contributions to his nation’s victories in wartime. Whoever should first find this note might not know him at all. For clarity, then, he’d signed his name in full, as one might put a finish to a legal document.")]), _vm._v(" "), _c('p', {
    staticClass: "blocky"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("God keep you; and the Lord have mercy on my soul.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Edwin Howard Armstrong")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("At the turn of the twentieth century, the national mind was alive and brimming with wondrous possibilities. Our heroes were the adventurers, the explorers, the visionaries, and the inventors. Even small children knew their names.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Their promises were breathtaking: One day soon winged vehicles would fill the skies and rockets would venture beyond Earth’s atmosphere; automobiles would be as common as horse-drawn carts and buggies; synthetic materials and mechanized workers would ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("revolutionize manufacturing and agriculture; great works of art and theater would be beamed to every living room in moving pictures, real as life; new medicines would eliminate dread diseases; new forms of abundant energy would bring security and prosperity to every hearth and home; and thinking machines would sit upon our desks to help us solve the profound mysteries still facing mankind.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not an era for timid bystanders. The means to pursue the next amazing breakthrough were available to every thinking man and woman. Their laboratories were attics, basements, and garages, and every citizen scientist with the will, the intellect, a blackboard, and hand tools could feel in their grasp the potential to change the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As that new century dawned, a great unexplored frontier awaited man’s conquest: the still primitive, misunderstood medium that would one day be called "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("radio.")]), _vm._v(" The wireless transmission of information across many miles through invisible airborne waves was the stuff of dreams, and its pursuit captured the ambitions of three very different men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee de Forest, David Sarnoff, and Edwin Howard Armstrong all ran the same race on separate courses toward an unknown finish line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only one would ever cross it.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("48 Years Earlier")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Yonkers, New York")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("April 4, 1906")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Edwin! Edwin Armstrong, you come down from there this instant!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He could barely hear his mother’s voice over the noise of the wind singing through the wires all around him. He’d heard enough to know she was angry, though—she only brandished “Edwin Armstrong” when she was mad as a wet hornet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man was sitting in a bosun’s chair a hundred feet above the ground, suspended by four thin ropes alongside his latest and greatest antenna. He’d finished work on the tower almost an hour before, but he loved the feel of the air up there. If given a choice he would probably never come down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll be inside in a few minutes!” he shouted.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“Not in a few minutes, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("now")]), _vm._v(". And I mean "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("right now")]), _vm._v("! And if you break your neck, Howard Armstrong, don’t you dare come running to me!”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When his mom had turned and gone back inside in a huff, he made his way down to join the family for dinner. It was a generous meal at one of many regular gatherings with his parents and sisters and most of his uncles and aunts and cousins. As the food was passed around the table, his relatives quizzed him about his latest experiments, and then listened intently as if his words were the most important ever spoken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though his mom was still a little miffed at his earlier high-wire act, Howard could tell she’d forgiven him yet again. She believed in him, they all did, and there was never a doubt in his mind that within the comforting walls of this big, beautiful home, he was loved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Howard never blamed his mother for being overly protective. She’d almost lost him when he was eight and came down with rheumatic fever. There were complications—he’d missed two years of school, and the disease had left him with a tremor and a tic in his face that still dogged him to this day, especially when he was nervous. That’s why they’d moved from their beloved Manhattan to this spacious home in tranquil Yonkers. His parents wanted the best for their only son, and his entire family had been there to nurse him through his long recovery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to his fascination with great heights and his love of all things electrical, Howard had also learned to treasure solitude. In the quiet and safety of his attic laboratory, his mind was free to explore. Although he was humble to a fault, he also understood that he was gifted. When a family friend had seen his first crystal set—a cobbled-together little wonder that he’d created from scratch—the friend had declared him to be a true prodigy. Though he’d had to look up that word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("prodigy")]), _vm._v(" in the dictionary, something told Howard that what this visiting engineer had whispered to his dad might really be true.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Where others saw just a tangled box of components and wires, Howard couldn’t help but visualize the myriad ways they might be connected. As he read through "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Boy’s Book of Inventions")]), _vm._v(" the concepts came alive before his eyes. He could see within the black-and-white circuits and schematics the interplay of flowing currents, the ebb and ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("flow of resistance, impedance, reactance, capacitance, and induction. He could see in these forces the seeds of great discoveries—a world-changing treasure just waiting to be found.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Then there was radio—which was currently nothing more than a curiosity, a hobbyist’s toy beyond the means of most laymen. An elaborate antenna, a pair of sensitive headphones, and an expensive receiver were required just to pull in a weak, scratchy signal from any distance at all. But in those waves of airborne electricity and magnetism, young Howard Armstrong saw an amazing untapped potential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was an idea that consumed him. To bring the wonders of radio—not just simple code, but voice, and someday even music—loud and clear into every American home. Just the thought of it made his heart race.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Howard’s prized possession was a strange glass tube, placed in a position of honor on his attic workbench. He’d saved his pennies and sent away for it by mail, after reading all about it in the back pages of an inventors’ magazine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The thing was called an Audion—and while the flashy ad had promised miracles, in retrospect, Howard had to admit that the copy had been very short on actual facts. Even its inventor—a man named Lee de Forest—seemed to have very little concept of the Audion’s practical use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Howard knew his savings hadn’t gone to waste. Like Jack with his magic beans, he sensed a mystic potential in this odd glass tube and believed with all his heart that it was the pathway to an undiscovered realm—one that Edwin Howard Armstrong knew he was born to explore.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("Six Years Later")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("October 1912")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("In the closing months of his twenty-second year, Armstrong still sat in that same chair in his attic lab, but many things had changed. He was now a student at Columbia, excelling in the engineering program ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("under the tutelage of the great physicist Michael Pupin. Most of his boyhood dreams were in the process of being realized, but one had continued to elude him throughout his college years.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tonight, however, he thought with a smile, that just might change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Between classes Howard had continued his obsessive work with the Audion, commuting to Manhattan every day by motorcycle so that he could return to a long night of experimentation in his workshop at home. That evening he could feel in the air that all his hard work and sacrifice was about to pay off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared hard at the circuit he’d just constructed—a design that had come to him in a flash of inspiration—and thought back to how he’d arrived at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Current radio signals were far too weak to be heard without headphones pressed against the ears—even at a moderate distance. Mere audio amplification wasn’t enough—that only made the faint signals fade into the background noise. The answer had to be to somehow amplify the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("signal")]), _vm._v(" itself, not just the resulting sound.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Audion produced only a modest improvement in the faint signals, but what if . . . "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("what if the output of the Audion were fed right back into its input again?")]), _vm._v(" Electrons travel at the speed of light—he could feed the signal back a hundred times, a thousand times, even twenty thousand times, all in the blink of an eye, and the Audion would compound its tiny amplification with every single pass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That electronic snowball effect was the very idea that Howard was about to put to the test.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong sat in the dim candlelight, making final adjustments. When all was ready he set the tuning capacitor all the way to the bottom of the band and turned a potentiometer that he’d labeled "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("regeneration")]), _vm._v(" ever so slowly clockwise. Near the middle of the range he backed it off as a high-pitched squeal began to develop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So far, so good. Now, with the delicate touch of a safecracker, he twisted the metal tuner knob gently up the scale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again, and then again, another fraction of a turn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still nothing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("He sighed heavily and, for the first time in months, felt the nervous ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("tic flaring up at the corner of his eye. He was dog-tired from another day of hard study and a night spent on this fruitless work. Maybe it was finally time to throw in the towel, focus on finishing his degree, and save this wandering experimentation for his idle retirement years.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In frustration, he tweaked the control hard, one last time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A deafening tone pounded into his ears and he tore off the headphones in surprise. He could still hear it, though, loud and distorted, from where the ’phones dangled down at the end of the cord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stunned, his ears ringing, Armstrong reached out for the switch that would route the sound from the headphone jack into the tall amplifying horns he’d mounted beside his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The windows rattled from the blast of clear, strong sound that suddenly filled the room. It wasn’t just sound—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("it was a signal.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stumbled his way down the stairs to the second story, pounding on every door he passed until he burst into his eldest sister’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve done it!” Armstrong yelled. “I’ve done it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Done what?” she answered, her voice registering her sudden fright over what he might be talking about. “Howard, have you set the house on fire again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come with me now! You have to hear this!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But she could already hear it, even from the floor below. As he ran up the stairs with his sister close behind, the Morse code continued booming into the attic, clear as a bell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember this night, sis,” he said. “This is the night you’ll tell your grandchildren about: the night that radio changed forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s so loud!” she shouted back, with her hands cupped over her ears. “Where’s this guy transmitting from anyway, our kitchen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong held up his hand for silence, his eyes growing wide as he mentally translated the incoming dots and dashes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honolulu,” he whispered. “It’s coming from Hawaii. Five thousand miles away.”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Michael Pupin, Howard Armstrong’s self-appointed mentor, often felt like a fretting mother hen. Armstrong could be strong-willed, even obstinate, and he often showed little regard for his own safety, either physically or legally. But Armstrong was also, hands down, the most ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("brilliant student he’d ever taught—maybe the most gifted and principled man he’d ever "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("met")]), _vm._v(". Given that Pupin had worked with the greatest names of his day, that was saying a lot.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Howard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong didn’t answer. He was working away in his corner of the lab at Columbia, in the basement below Philosophy Hall, up to the elbows in a new receiver he’d spent months perfecting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a little Christmas party tonight, Howard. Some of the students were asking if you’d come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Busy,” Armstrong said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Howard, you told me you finished your patent applications, and I’d like to review them now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On the table, over there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Pupin waded through the legalese he identified a problem almost immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is incomplete,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then talk to the paper pushers,” Armstrong replied. “I’ve spent too much energy on that mumbo jumbo already.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Too much energy? Howard, you’re a year behind in completing this filing. You have to protect yourself. This is important—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Armstrong said, “"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("this")]), _vm._v(" is important, this work right here in front of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This application describes a patent for a radio receiving system.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s only a small part of it,” Pupin continued. “You’ve shown me that your regenerative system can actually "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("modulate")]), _vm._v(" a signal, and when you push it into oscillation, it becomes a transmitter as well. One unit that can both send and receive, clear enough for voice and even music.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I haven’t had time to perfect all that yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perfection be damned, it’s the heart of the invention!” Pupin said. “With this idea the guts of a radio transmitter can be shrunk from the size of a closet down to a box I can carry in my hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When it’s ready, I’ll announce it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“You have a neighbor in Yonkers who’s a patent attorney, and a very ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("good one. He’s of national renown. Why haven’t you asked him for his help?”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t trust lawyers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Howard, listen to me. That Audion tube in your circuit is the work of a dangerous man—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Dangerous?”")]), _vm._v(" Armstrong laughed. “Lee de Forest? I’ve heard the man speak at the Institute of Radio Engineers. He doesn’t even know how his tube works.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter if he knows how it works, it only matters what a judge and jury will believe.” Pupin came closer, and sat by Armstrong’s side. “I know for a fact that he pickpocketed the work of Reginald Fessenden, and then he tied him up in court for years. And de Forest won. Then he sued John Fleming, the man who invented the Fleming valve, the very basis of the Audion, and he won again. He shouldn’t have won, but he did. De Forest seems to thrive on legal wrangling, and I’ve heard it said that you’re the next name on his blacklist. You have too much to offer to waste your life in litigation. I don’t want that to happen to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It won’t happen to me,” Armstrong said. “Yes, my work incorporates the Audion. Does that mean de Forest invented regeneration? Could the caveman who first chipped out a stone wheel claim to be the father of the Model T Ford? It’s absurd.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Absurd, yes, Pupin thought. But there were so few true geniuses to be found in the pages of history, and there has never been a shortage of opportunists and predators. Armstrong was a young man of great integrity, and such men can make the fatal mistake of assuming integrity in others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wanted to say more, but he knew that at some point the teacher must let the student venture forth from the safety of the nest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t work too hard tonight, Howard,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s no such thing as working too hard,” Armstrong replied, but by then his mentor had already left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He surveyed his work one last time, then sat back and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Absolutely perfect.")])]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("Belmar, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("January 31, 1914")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A very important man had contacted Armstrong for a demonstration of his latest receiver. Armstrong had been preparing for their meeting for weeks now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He arrived early to set up, but when he pulled into the drive his appointment was already there, waiting for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To his surprise, Armstrong noted the man was around his own age, maybe twenty-one or twenty-two, but he was dressed to the nines like a Wall Street wheeler-dealer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Edwin Armstrong,” he said, as the two shook hands. “My friends call me Howard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I’m the chief technology inspector and contracts manager for the Marconi Wireless Telegraph Company,” the other young man replied. “I don’t have any friends, but my enemies call me Mr. David Sarnoff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They hit it off right away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The conversation was easy, like a reunion of old acquaintances. They talked of many things as Armstrong opened the trunk and the two of them worked together to set up the equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarnoff was a son of Jewish immigrants who’d come to America with little more than the clothes on their backs and hopes of a better life. A natural businessman, he’d been earning his keep since childhood, and overcoming every hurdle of prejudice and poverty as he clawed his way up the ladder. By the time he was fourteen he’d bought his own newsstand and put his four siblings to work for him. Now, less than a decade later, he held a position that would have been coveted by ambitious men twice his age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though their backgrounds and disciplines were very different, it turned out their dreams of broadcast radio were the same. Both believed the radio receiver would one day be a treasured fixture in every American living room. Sarnoff seemed to have a plan to actually make that happen.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("“Wait a minute, I’ve heard of you,” Armstrong said, as he connected the feed line and completed his final checks. “David Sarnoff, yeah. ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("When the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Titanic")]), _vm._v(" went down, the newspapers said you stayed at the telegraph key for three straight days, getting messages out to the families. The reporters called you the wonder boy of radio.”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong looked him over again. “Is all of that really true?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, it wasn’t true back then,” Sarnoff replied, with a conspiratorial wink, “but brother, it sure is now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Armstrong fired up the receiver, the two took turns tuning in far-flung stations and copying the incoming Morse code. They hit Ireland, Nova Scotia, Hawaii, and San Francisco—there seemed to be no limit to the range from which this amazing apparatus could receive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve seen enough,” Sarnoff said at last, laying his earphones on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me tell you how it works.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t really care how it works.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Howard, relax. This receiver you’ve made, it’s not just a breakthrough, like you said in your letter—it’s the most remarkable radio receiving system in existence. It’s a revolution.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, that means . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That means I’m going to recommend that Marconi license your invention. And that, my friend—assuming all your paperwork’s in order—means you’ll be making as much every month as most people make in a year.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say that again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarnoff smiled. “Probably five hundred dollars per month, Howard, for this invention alone. And I’ve got a feeling this is only the beginning.”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Twenty miles away, Lee de Forest paced the floor in his small studio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his youth, both Nikola Tesla and Guglielmo Marconi had turned down Lee de Forest’s generous offer to lend them his genius. That blowhard Marconi hadn’t even bothered to answer de Forest’s formal letter of introduction.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("At twenty-eight years old and on the verge of greatness, de Forest had been fired from his job by the dolts at the American Wireless ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Telegraph Company. His crime? He’d refused to surrender all rights to his work and into the grasping hands of his greedy employer! He’d then bravely struck out on his own, only to see his dreams crushed again and again by unscrupulous partners and overzealous minions of the law.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Since the failure of his first company, he had ridden several more of them into the ground. Some of his new partners had been convicted for stock irregularities, and de Forest himself had only recently been narrowly acquitted on a trumped-up charge of fraud. The prosecutors had accused him of selling worthless pieces of junk—including his precious Audion!—and thereby fleecing hundreds of unsuspecting hobbyists by mail order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mistreated, disrespected, and misunderstood—such was the path of a genius in a backward world. Over the years he’d been twice married and divorced, and betrayed many times over by a series of businessmen who only wanted to use his brilliance for their ill-gotten gains. But at last he was free from all of them, and determined to make a fresh start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon, he swore, he would show them. When "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("de Forest")]), _vm._v(" was a household name, etched into history alongside those of Ohm, Volta, Faraday, Watt, Hertz, Joule, Henry, Galvani, and Ampère—then they would all be cursing the day they’d dared to disrespect him. This would be marked as the moment in history when Lee de Forest began his Phoenix rise into legend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the last of his dwindling savings, de Forest had begun to broadcast little short-range programs of music and news in the city. It was a humble rebirth, but a foundation he could build on. He had made a firm resolution that he wouldn’t be stolen from again. More than that, he would take back what was his from all those who sought to rob him of his rightful legacy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several months earlier, there’d been rumors floating around that some local upstart had used his Audion in a receiver of extraordinary design. Now that wop bastard Marconi had licensed the design, no doubt to rub salt in de Forest’s wounds, and he was soon to begin cranking out receivers like link sausages.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("There was more. This young thief, fourteen years his junior, this ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Edwin Howard Armstrong, actually had the unmitigated gall to patent the stolen goods under his own name. When the true inventor, de Forest himself, had tried twice to submit his own registration for his new Ultra-Audion receiver, he was flatly turned down in favor of the younger man’s fraudulent precedent.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This could not stand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee de Forest vowed he would win back his greatest invention, secure all rights to its use, and destroy this charlatan, Howard Armstrong—even if it took the rest of his natural life.")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("1917")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Howard Armstrong stood outside the courtroom, waiting. He could feel the twitching in his neck and at the corner of his eye, and he wished hard that for once he could just make it stop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Lee de Forest had filed this patent suit against him in 1915, the lawyers all assured Armstrong that the case would never get to trial. When it did get to trial, they told him it would all be over soon. Now, almost two years later, his bank account was almost empty and still the case showed no sign of resolution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Try to relax, Howard,” his attorney said. “You’ve got a big afternoon ahead on the stand.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can I relax? Yesterday I had to listen to de Forest blather on for four straight hours. Any thinking man could tell that he doesn’t understand even the most basic principles of radio. He couldn’t even explain oscillation! And the judge sat there nodding his head through it all, as though what he was hearing made perfect logical sense!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The judge isn’t an expert.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then where are the experts to testify on my behalf? Three days ago, the Institute of Radio Engineers awarded their first ever Medal of Honor to me for the development of the regenerative receiver—the very invention in conflict here. That’s how important this discovery is. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("My discovery.")]), _vm._v(" And those men and women at the institute, above all others in the world, they know who rightfully deserved it—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“Nevertheless,” his attorney interrupted, “de Forest claims he ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("discovered regeneration two years before you did. He just didn’t get around to patenting it.”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Balderdash! So the fox catches a rabbit, and then waits two years to eat it? De Forest files patents like Carter makes pills. Any fool could see that if he knew how to create what I created he never would have waited.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And they’ll bring up the fact that you didn’t answer the allegations in the suit immediately.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My father had just drowned that very month, and I had to take up the support of my family. I couldn’t be bothered with this claptrap then, and I haven’t the time or the money or the patience to be bothered with it now! I must get back to my work—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Howard, please, just lower your voice and calm down. You don’t want to look nervous, or angry, or insulted to be here. We’ll present your case as we’ve laid it out. You’ll answer the questions simply and honestly, and trust me, we can wrap this thing up in another week or so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But a month passed, and another, and it still wasn’t over. Then one morning, the world turned upside down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Woodrow Wilson had been reelected president on a solemn promise to keep the United States away from the bloody battlefields spreading across the world. But on April 2, 1917, the president had gone before Congress to request a declaration of war on Germany. Four days later, both the Senate and the House had voted to commit U.S. troops to join in the conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Great War, they called it. The war to end them all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though no one had asked him, Lee de Forest had immediately gone on record to say that he wouldn’t be supporting the effort. Why should he risk his own life, he’d asked, to defend the characterless, incohesive goulash that was the American people? He would gladly sell the military anything they needed from his inventory, however, just like any other paying customer, at the current retail price.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For his part, Armstrong enlisted immediately into the Army Signal Corps. At the same time, he turned over the patents to all his inventions, free of charge, for the wartime benefit of the U.S. government.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("All domestic transmitters were immediately commandeered, and production of new units flew into high gear. Though the technology ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("was still primitive, it was clear that wireless communications would play a vital role for the Allied and Associated Powers.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Naturally, all trivial matters such as patent lawsuits were suspended by fiat until further notice. At least that burden was lifted from Armstrong’s shoulders, if only temporarily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a captain in the Signal Corps, his first base of operations was the radio labs in Paris. Advanced German aeroplanes were terrorizing the skies over Europe, and the tactical use of their own young radio technology was a major factor to be overcome. Howard Armstrong was charged with helping the United States to level this key playing field.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First on the agenda was the improvement of wireless radio links between Allied airborne scouts and fighter aircraft and their commanders on the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Don’t go so easy!” Howard Armstrong shouted forward to the pilot. “Fly her like you’d take her into battle!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’d never catch me flying this hunk of junk into a fight!” the pilot shouted back. He put the open-cockpit Sopwith Scout into a hard bank and swooped into a descending turn. The wings flexed and the canvas-covered wooden fuselage creaked and complained, but the craft seemed to be holding together for the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This outdated model had a nickname among the aviators at the Paris base—they called it the Spinning Jenny. But, death trap or not, it was the only two-seater available for Armstrong’s tests, so the rickety old plane would have to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put on his headphones and set about tuning and adjusting the transceiver in his lap. It was almost impossible to hear anything at all. The wind, vibration, and engine noise were compounded by a whine of ignition static fouling the receiver. Signals from other planes and ground stations crowded in and jammed one another. When he transmitted, the base seemed to hear only a small portion of what was sent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On top of these problems, the radio was heavy and complicated, with multiple interacting controls. It would be a headache to tune this properly on a workbench indoors, much less in the jump seat of an aircraft in the midst of a bombing raid. There were so many delicate parts inside that breakdowns would be a daily occurrence.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("“Okay, take her down!” Armstrong shouted. “I’ve seen what I need to!”")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Back at the lab he left the notes with his new assistant, Sergeant Harry Houck, and then went out for a walk to think through his current stack of challenges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Germans used innovative, high-frequency methods in their communications—“short waves” that were far outside the reach of older receivers. Intelligence services first needed to intercept those transmissions before they’d have any hope of decoding them. Bombing raids were a growing danger, and if radio could be used to detect the faint ignition noise from incoming planes it might be possible to get an early warning. Wireless location-finding also had to be improved so enemy ships and even troop movements could better be detected. As Armstrong had just seen firsthand, portable receivers required a complete redesign if two-way radio was ever going to be put to effective use in the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many lives depended on quick solutions to these problems. Despite the relentless pace, Armstrong’s nerves hadn’t bothered him once. This was exactly the sort of pressure he loved. For the first time in years there was a blessed refuge of calm and quiet in his mind. With no lawyers, writs, subpoenas, or injunctions to drain his spirit away, he was finally able to once again devote himself to pure invention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the midst of that thought Armstrong stopped walking, right in the middle of the street. A schematic circuit diagram was revealing itself before his eyes, like the dawning image on a photographic plate in a cloudy darkroom tray. It was the solution—not only to one of the challenges he faced, but to possibly "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("every")]), _vm._v(" one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned and began to run back toward the lab, suddenly frightened this image might fade and decades of progress in radio might be lost in trying to summon it forth again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Harry, I’ve found it!” Armstrong shouted as he burst into the workroom and set about erasing the long blackboard by his bench. They’d spent the previous week writing out their long-term research plans there, but his assistant knew better than to object.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("“What have you found?” Houck asked, but Armstrong was already ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("deep inside his own mind, drawing whatever it was that had possessed him.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When Houck began to understand what he was seeing, he joined his leader at the board, and for hours the two men worked without a word until the diagram was finally complete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inventors don’t always see the potential of a stroke of genius in the moment it arrives. But as they stood back and took in what they’d just brought into the world, both men knew they’d made history, and had changed the science of radio forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong had set out to provide a leap forward in the clarity of radio signals, to improve long-distance reception and dampen interference, to make receivers simple to tune by an untrained operator, and to open the door to wireless direction-finding breakthroughs that could change the course of the war. He’d solved it all in a single stroke")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would be called the superheterodyne.")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("1924")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Great War had been over for years, but David Sarnoff knew his corporate battles would probably never end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marconi had been absorbed into the new Radio Corporation of America, and though he was still only in his mid-twenties, Sarnoff found himself second in command at RCA. He’d dreamed of broadcast entertainment and a radio receiver in every American home. Now, with RCA booming and its fledgling National Broadcasting Company poised to take off nationwide, those dreams were fast becoming reality. That success had brought competitors crawling out of the woodwork on every side.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Howard Armstrong’s superheterodyne had made practical the mass production of receivers that were simple enough for average people to use. Through some brilliant business hocus-pocus, Sarnoff had both confounded his competitors and leveraged his friendship with Armstrong to create a slim window of opportunity for RCA to be first to market. The admen had named the company’s flagship set the Radiola, and the copy was right on target.")]), _vm._v(" "), _c('p', {
    staticClass: "blockfc"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("You will agree with Marconi")])]), _vm._v(" "), _c('p', {
    staticClass: "blockfc"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("When you hear the sensational new")])]), _vm._v(" "), _c('p', {
    staticClass: "blockfc"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Radiola Super-Heterodyne")])]), _vm._v(" "), _c('p', {
    staticClass: "blockfz"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("acclaimed by inventor of radio as “a great advance”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("But there was trouble in paradise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong’s prototypes had worked like a charm, but after the R&D labs at General Electric and Westinghouse had put their thumbprint on the design, the result was noisy, quirky, and so heavy it was just barely portable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having created massive consumer demand, and with his nervous stockholders and dealerships awaiting a payoff on their investments, Sarnoff had just canceled millions of dollars in manufacturing orders for a product he considered too flawed to produce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was known as a man with all the answers, but for once David Sarnoff had no idea what to do next.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not call Armstrong?” his secretary asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This bright young woman, Marion MacInnes, had already pulled Sarnoff’s fat from the fire on more than one occasion. She was sitting at her desk, looking dreamily at a photograph of Howard Armstrong—the very picture that had gotten him banned from the corporate premises. The photo showed the still-boyish inventor balanced on the peak of the 450-foot antenna atop the RCA building at 30 Rockefeller Center. When the papers ran the shot, the insurance guys went apoplectic and probably would have had Armstrong arrested if Sarnoff hadn’t intervened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Armstrong—now that wasn’t such a bad idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get him up here,” Sarnoff said, “and alert security to let him through. But so help me, Marion, if he climbs that tower again, genius or not, he’s going to spend the night in jail.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two men met on the roof of the building, far from the prying eyes of the fretting RCA executives. As Armstrong pored over the production schematics for the Radiola, he and Sarnoff had a few quiet minutes to reminisce.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never got a chance to apologize to you,” Armstrong said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For what?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("“For selling the rights to the superheterodyne to Westinghouse. I didn’t want to leave you out, but I couldn’t wait. I needed the money for the lawyers.”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was pretty hot about that for a while,” Sarnoff admitted, “but all’s forgiven. Let’s just say that deals were made, and I made sure I came out on top. Now I’ve got Westinghouse and GE right where I want them. AT&T is even trying to stick their nose into this business, but we’re holding them off as well.” He would have gone on, but as he watched Armstrong for a few moments more, he realized that his old friend really had no capacity for the nuance of this sort of war. “You’re still fighting de Forest, then, on regeneration? How long has that been going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Almost ten years now. I won against him in ’21, and then he appealed and now I’m set to win again. When that verdict comes down I’m going to run up a flag with my patent number on it, big enough that he can see it from his house on the Hudson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not just drop it? Settle, and move on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s sworn he’ll never pay damages to me until he’s lost in the highest court in the land.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then waive damages and take your win. Make de Forest buy a license if he wants to use your work. That’ll burn him up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are some things a man can’t compromise on. It’s not only the money I’m owed. You’ve heard what he says about me to any hack reporter who’ll listen. He calls me a thief.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re in good company. You should hear some of the mud he slings about Marconi, though being an eyewitness, I can confirm that some of the more lurid tales of his appetite for the ladies are absolutely true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that’s certainly more than I ever wanted to know about Marconi’s love life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seriously though, Howard, as a friend, you should think hard about cutting your losses with this de Forest business. Put it behind you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t give it up, David. It’s my reputation at stake.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("“Ten years,” Sarnoff sighed. “It’s a crime, that’s what it is.” He could see a change come over Armstrong as he spoke of the case—the constant pressure must have been tearing him down, bit by bit. “Well, let’s ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("hope old Lee does as bad a job before the Supreme Court as he does at reporting the news. Remember the night when he called the 1916 presidential election? "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("‘Breaking news! Charles Evans Hughes beats Woodrow Wilson!’")]), _vm._v(" He splashed that scoop all over the tri-state area, and then he stuck by it for almost a week.”")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong smiled, but there was no joy in it. Sarnoff thought it probably best to change the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of money,” Sarnoff continued, “I’m sitting on orders for one hundred thousand radio sets, and I don’t have a single one to deliver. Do you think you can help me with that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Howard Armstrong put the drawings aside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell you what. If I can do it, I want a signed letter on your stationery, giving me permanent permission to climb that antenna tower behind us any damned time I want.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll do better than that,” Sarnoff said. “I’ve got a lovely young woman downstairs, right outside my office, who’s got a crush on you to beat the band. You give me the Radiola, and I’ll introduce you to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This time Armstrong’s smile was genuine. He held out his hand, and they shook on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And there’s one other thing I want you to start thinking about,” Sarnoff said. “I was listening to our stations the other night, during that big rain, and the static was awful. From March until October we have to print a damned weather report right next to the program listings in the paper so people can see if the storms will wipe out their reception. You find me a way to eliminate that noise, clean up our signal regardless of the weather, and we’ll own this industry for the next fifty years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll give it some thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And Howard, listen to me,” Sarnoff said. His tone was serious. “It’s a bitter world we’re operating in. There are empires at stake, and that’s much bigger than you and me. That’s bigger than friendship. This suit with de Forest? You must know he’s got AT&T behind him now. You can’t win alone anymore. The age of the independent inventor is over and done. You’ve strayed in the past and I understand why. But if you stick with me, you’ll own the future.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("“I won’t believe that, David. I think the world of you, but I’ll never ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("be a company man. You’ve got big ideas, I know, but I’ve got a few of my own.”")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarnoff nodded. “I’ve heard that assistant of yours call you ‘the Major.’ That’s from the war, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, around here they call me ‘the General.’ I’m going to be running this place before you know it, and RCA is only the beginning. And Howard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarnoff put a hand on his old friend’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mustn’t ever forget that a general outranks a major.”")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("1934")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The ten years that followed ushered in a world of change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were times of happiness greater than Howard Armstrong had ever known. He’d found his one true love in Sarnoff’s assistant, Marion MacInnes, and after a blissful courtship they’d been married. Together with Harry Houck, Armstrong had solved the mass production problems and David Sarnoff had sold his hundred thousand receivers, and then many hundreds of thousands more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With eighteen thousand shares of company stock as his reward, Armstrong had become the largest single shareholder in RCA. But the Depression took its toll. Stock that had been worth $572 per share in 1929 had plummeted to just $12.25 by 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As an industry, radio was coming into its own. They were already calling it the “Golden Age of Broadcasting.” Even as unemployment soared, people who struggled to buy food and pay the rent never missed a payment on their radio sets. It was a gathering place for the troubled nation. The airwaves were filled with popular music, news, and sporting events, as well as comedy and drama from the greatest stars of the day. Even the president regularly went on the air to reassure his fellow Americans that happy days would soon be here again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It certainly didn’t seem that way to Howard Armstrong.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("By then "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("de Forest vs. Armstrong")]), _vm._v(" had been heard by a dozen courts, with wins, losses and stalemates claimed by both litigants. After all this, the Supreme Court of the United States had just issued its decision on the matter.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Through what could only be explained as a complete misunderstanding of the technical foundation of the case, the court had ruled against Edwin Howard Armstrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, after almost twenty years, the verdict of history was now etched in stone: Lee de Forest had won. Armstrong was a thief.")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("May 29, 1934")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Howard Armstrong stood in the wings awaiting his introduction at an annual meeting of the Institute of Radio Engineers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d been invited to give that night’s keynote speech long before the Supreme Court’s decision had come down. It was a standing-room-only crowd, and by now most everyone in the audience knew of the ruling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though Armstrong dreaded yet another round of public humiliation, he had never broken a commitment to his peers. He was sure, however, that his planned presentation on frequency modulation would now be inappropriate to deliver. He would keep his notes in his pocket. There was only one thing he needed to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he took to the stage the crowd was mostly silent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My friends,” Armstrong began, “and my colleagues. As you may be aware, my long fight with Mr. de Forest has finally come to a close. It has been the longest such case thus far in American history, and it was brought to determine who is the rightful inventor of regeneration. The verdict of the high court has now been rendered, and it was not the outcome that I’d hoped to see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He could feel a twitching begin in his neck, and he held a grip on the podium to try to keep it down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In 1917, this organization saw fit to award to me its Medal of Honor for the discovery of that very principle. I will never forget that night. To me it seems like only yesterday, and yet it was so long ago.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Emotion rose into his throat and took hold there. Only a few more words needed to be spoken, and he prayed he could deliver them.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“With the Supreme Court’s decision, I no longer have a right to the honor that you so graciously bestowed upon me.” He took the small engraved plaque from his coat pocket and placed it on the table beside him. “I only wish—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A single shout of “No!” arose from the back of the auditorium.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another man yelled out, “It’s yours, Howard, and we all know it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My friends,” Armstrong began again, but his voice failed him. He felt the first tears begin trailing down his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Others in the audience started to join in the vocal protest. Applause began slowly and then spread throughout the room until the roar of it was ringing in his ears. The engineers were coming to their feet in an ovation that seemed as if it would never end. They were cheering and chanting his name, and then one of them ran up onto the stage and put Howard Armstrong’s treasured award right back into his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When he got home from the meeting he told Marion all about it, and the two stayed up most of the night talking about the future. She’d been by his side through virtually every trial and tribulation, lending him her strength, and he loved her more every single day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By morning, for the first time in years, the road ahead seemed bright.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ever since David Sarnoff had asked him to tackle the static problem, Armstrong had been quietly at work. The challenge had been monumental, but now the prototype was nearly done—and wide-band frequency modulation would be an invention all his own that no man alive could ever dispute. Outside his wife and Harry Houck, only Sarnoff, now the president of RCA, had been privy to the progress so far. Finally, it was ready to be announced.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Armstrong wrote in his journal that morning:")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("An era as new and distinct in the radio art as that of regeneration is now upon us. After ten years of eclipse, my star is rising again.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A few sleepless days and nights later, a team of company engineers assembled in Armstrong’s temporary lab at RCA headquarters.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("Howard turned on the latest model of the Radiola and then tuned in a signal until the sound was as clear as he could make it. There was music playing, a classical piece, exhibiting the thin, tinny audio of a typical program of the day.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are two transmitters upstairs,” Armstrong said. “One is broadcasting with yesterday’s technology, and that’s what you’re hearing now. Watch, and listen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong flipped a switch near him and a spark generator began spitting bright white arcs of electricity across its gap. The radio signal was immediately overwhelmed by interference and the program disappeared into the hiss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sweeping gesture, Howard Armstrong then switched the output to the new FM receiver right beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same orchestra music filled the room, but the difference was breathtaking. For minutes they all listened in utter fascination—for the first time, a broadcast signal carried the full audio spectrum discernible to the human ear. And despite the static generator that was still going strong, the reception was so pure and clear that one could hear the whisper-quiet sound of the violinist turning his pages of music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the demonstration was over, David Sarnoff dismissed his team of engineers to the next room and took Armstrong aside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you’ve done it again, Howard,” he said. “This FM business, it’s going to change everything one day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One day?” Armstrong replied. “It’s changed everything already, starting "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("today")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s sit down over here,” Sarnoff said. When they arrived at the table, Armstrong saw what looked like a corporate contract was already waiting for them. “This is an agreement between you and RCA. Among other things it entitles you to a significant share of the profits that might come from your work here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong began to read. His enthusiasm began to leave him, though, before he’d even gotten halfway through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This transfers all my patents for FM over to your company.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right. You and I will always know who invented it, but to the rest of the world, FM will belong to RCA. And that’s not all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("“I’m not going to announce these results,” Sarnoff said, “and neither will you. Nothing you showed us here today will be made public.”")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean? You said this was another revolution—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And it is, but we’re not ready for it yet. We’ve only just gotten AM into widespread acceptance. I’ve got millions of radio sets out there in the market, and tens of millions more on the production line. That gear would all be obsolete, not to mention the stations and broadcasters who’d all have to replace their equipment overnight. Once people hear your new system, they’d never want to listen to AM radio again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s wonderful—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Howard, it’s not wonderful. It’s a threat to the fortunes of a thousand men that you don’t want to cross. More than that, they would never allow you to cross them, and neither will I. You’re right about one thing, this is the future, and you should be proud of what you’ve done. But the future has to wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong was getting angry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I won’t do it. What if I don’t sign? Then what are you going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t want to find that out, Howard. Don’t you read the business section? I don’t get ulcers, brother, I give them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re going to threaten me now? Don’t make me laugh! The patents are mine—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did de Forest teach you nothing at all? Do you really imagine you can walk out on this deal with any hope of beating me at my own game?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not walking out,” Armstrong said. “This is my laboratory—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, it isn’t, Howard, not if you turn this down. And I take it your answer is no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” Sarnoff said. “You’ve got until the end of the day to pack up and clear out. You can go back to that basement at the university because I need my space here for another team. While you’ve been playing around with radio, we’ve been working on something much bigger.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarnoff paused to let the tension build.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Television.”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("Over the next few years Howard Armstrong poured every ounce of time and energy into the uphill battle of promoting the benefits of FM radio.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The costs were astronomical. He created a production chain to make and sell receivers to a growing number of enthusiasts along the East Coast. He sold franchises and licensed other entrepreneurs to manufacture his name-brand sets. At the same time, he built a 40-kilowatt FM radio station, W2XMN, to transmit his high-fidelity broadcasts for a hundred miles in all directions. He also inked a deal with the Yankee Network to help them found the first FM radio conglomerate. Before long more than 200,000 listeners were tuning in to FM every day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was grueling work and the budget was always down to the bone, but he and Marion were happier than they’d ever been. Their destiny was in their own hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One afternoon, Armstrong returned to his small office to find David Sarnoff sitting in his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like what you’ve done with the place,” Sarnoff said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you doing here, David?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got one last offer for you,” Sarnoff said, sliding a document across the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At first glance it looked like the same offer that Armstrong had turned down long ago, with one notable change: Rather than a permanent share of all future profits from his FM patents, the figure was now a flat fee: one million dollars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why on earth would I accept this?” Armstrong asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because it’s the only way you’re ever going to win.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you kidding me? I’m on my way to half a million listeners. I have new stations on the drawing board from here to Chicago. Before long we’ll be as big as NBC.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you don’t believe any other thing I say today, Howard, believe this: That will never, ever happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A million dollars? Just my facilities here are worth more than that, not to mention future earnings on FM. I wouldn’t sign my rights away for a hundred times what you’ve offered.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("“Last chance,” Sarnoff said, but there was no reply. He shook his head and stood, and then he took his time to fold and pocket the ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("rejected contract. “Very well, then. Get a long last look at this friendly face, Howard. Because the next time we meet, I’m afraid you’re going to see another side of it.”")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the back of his limousine on the way back to New York, David Sarnoff picked up the handset of the car’s intercom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Make a note on my schedule,” he said. “When I walk into my office I want a conference call waiting with Frank McNinch in Washington, D.C. . . . Yes . . . The office of the director at the Federal Communications Commission.”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The lawsuits began almost immediately. Some were filed against Howard Armstrong, and others Armstrong was forced to file himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The months tied up in court once again turned into years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("RCA was openly using FM technology for its television arm, while blatantly ignoring Armstrong’s patents. Rumors flew that Sarnoff was encouraging other corporations to disregard Armstrong’s patents as well. It became a sort of unspoken coalition, with a single unarmed man on one side and ten Goliaths on the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everywhere Armstrong turned a new wall rose in his path, but still he pressed on. At one point the opposing lawyers kept him coming back to the witness stand for over a year, asking him questions of no consequence to the case just to stall for time and wear him down. Then, one day, it was finally David Sarnoff’s turn to testify. Much of this time was a blur to Howard, but he would never forget what Sarnoff was about to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Armstrong has asserted,” the opposing attorney said, “that you once offered to pay him for the rights to develop FM technology, which he now claims to be his own original work. He’s put the figure in question at one million dollars. Is this true?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is not,” Sarnoff said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You never offered to pay Mr. Armstrong, on behalf of RCA, for the use of his work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At some point, I may have offered him something. We were old friends, you see, and he always seemed to be having legal troubles—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Armstrong’s lawyer objected to this, and as usual, was overruled.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("“In any case,” Sarnoff continued, “if I offered him anything it would ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("have been nowhere near the figure you mentioned. It would have been a gesture, nothing more.”")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Sarnoff,” his attorney began, “I’ll close with a simple question for you. Who developed FM?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David Sarnoff leaned forward to make sure the court could hear every word that he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The FM system that is in question here today was developed, beginning to end, by RCA. It is the sole invention of our corporate engineers.”")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("1941")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("On December 7, 1941, the United States was again thrown into war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As before, despite his own ongoing battles, Howard Armstrong immediately offered his services, and turned over every patent he held for the use of his country in the war effort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee de Forest, now sixty-eight years old, and always game for publicity, announced his development of a self-guided bomb to be used against enemy forces in the air campaign. At the demonstration, the bomb veered off course and nearly fell among the generals who’d gathered to witness its power. All in attendance left feeling lucky to have escaped with their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While David Sarnoff had been denied a navy commission back in 1917, this time was different. For the duration of the war he left the safety of the boardroom for an active role in support of the Allies. In the end, he directed the development of a communication system that helped make possible the invasion of Normandy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the war was finally over, it was back to business as usual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unbelievably, Howard Armstrong was still hanging on—refusing to back down. But Sarnoff had an ace in the hole that he’d hoped he’d never have to play.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarnoff made another phone call to Washington, and within a month of American Telephone & Telegraph joining his lobby, the ruling he’d requested came down from the FCC:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("The FM broadcast frequencies were to be permanently moved, far up the spectrum from where they’d always been. In that one stroke, every unit in existence that was designed for FM transmission and reception was rendered obsolete.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "left1"
  }, [_vm._v("River House Apartments, 13th Floor")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("East 52nd Street, New York City")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("January 31, 1954")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Edwin Howard Armstrong had held on for nearly nine years more. Royalties had dwindled, debts were piling up, his health was failing, his savings were gone, and his hard-fought patents were about to expire. Just over two months earlier, on Thanksgiving night, he had finally taken all he could stand.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“They’ll never let me alone!” he’d shouted. “They’ll keep after me until I’m broke or dead, and nobody cares which it is!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“I do, Howard,” Marion pleaded. In all these years together she’d thought she’d seen him at his worst, but this was different. “We can still get through this—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“But I can’t! Why won’t you see that? I’ve wasted my life and yours! Everything I’ve ever done means nothing!” In the midst of his rage he’d grabbed a fireplace poker and swung it again and again at the walls, the family photographs, and the many awards that were carefully arranged on the mantelpiece.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("When he’d looked at his wife again he was horrified by what he saw. In his blind anger he’d struck her. Marion’s arm was bleeding. For the first time since he’d met her he’d put fear into those beautiful eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The metal bar in his hand dropped to the floor and he fell to his knees in front of her, but she had already left him and run for the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("That was the last time he’d seen her, and the very last time he ever would.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("And so it ends,")]), _vm._v(" Armstrong whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been quite a chore to remove the air-conditioning unit from the bedroom window, but at last it came free and the way was clear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The night was cold, but he was well dressed for it. All that lay before him was that final step.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("He had always loved the feeling he got from standing way up high. That night, at that moment, the feeling was no different. His regrets were all behind him.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And with that thought, Edwin Howard Armstrong took a last deep breath, and then walked off into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "lefta"
  }, [_vm._v("EPILOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Armstrong’s body lay hidden until the next morning, crumpled and still on a third-floor landing. The maintenance man who discovered the body knew immediately who he’d found.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The suicide made the front page of every paper in town.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee de Forest got the news and quietly made a number of calls in pursuit of the gory details. He then issued a statement regarding the death of his long-standing enemy: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“Armstrong is dead, and I am alive, and hope to live on for many years. What a contrast!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("De Forest spent those remaining years constructing what he hoped would be an everlasting place for himself in history. He lobbied for a Nobel Prize and, also unsuccessfully, tried to convince his fourth wife to pen a glowing biography to be titled "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I Married a Genius.")]), _vm._v(" Among the source material was a sampling of future predictions he had made along the way:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("While theoretically and technically television may be feasible, commercially and financially it is an impossibility.")])]), _vm._v(" "), _c('p', {
    staticClass: "blocki"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I do not foresee “spaceships” to the Moon or Mars. Mortals must live and die on Earth or within its atmosphere!")])]), _vm._v(" "), _c('p', {
    staticClass: "blockib"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The transistor will more and more supplement, but never supplant, the Audion.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a PR stunt, his publicist once sent a letter made out to “The Father of Radio, Hollywood, California.” Upon its successful delivery to him, de Forest was to use it as proof to the newsmen of his unchallenged legacy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The letter was soon returned by the Postal Service, marked "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Addressee Unknown.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Though money isn’t everything, history records that when he passed away in 1961, Lee de Forest had less than $1,300 to his name.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When David Sarnoff was told of Armstrong’s suicide, he was quiet for a time, and then, as though he stood accused by the messenger, he said, “I did not kill Armstrong.” The company was closed on the afternoon of the funeral, and Sarnoff himself led a large group of mourners down the street to attend the service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marion Armstrong did not suffer her husband’s death in silence. Not long after he’d been laid to rest, she took up his many legal battles against some of the most powerful corporations in America.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Using funds from a settlement with RCA, Marion stood up to the giants one by one. Motorola, Philco, Admiral, Emerson, Sylvania, Packard Bell, and many others, by intent or oversight, had profited from the work of Howard Armstrong—and she believed that it was long past time for them to pay for it. But, for Marion, as with her late husband, it was never about the money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his ruling against Emerson Radio & Phonograph, Judge Edmund Palmieri found the corporation’s arguments on the up-for-grabs origins of FM to be “speculative, inconclusive, and unconvincing,” and declared that “Major Armstrong was truly a pioneer in the field in theory and in fact.” At last, FM belonged to Armstrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The decision was so definitive that Emerson’s lawyers saw no hope in an appeal. Upon learning of this result, several other companies who’d banked on similar cases suddenly proposed generous out-of-court settlements. The last holdout, Motorola, lost their final appeal in October 1967. More than half a century since the legal challenges began, and thirteen years after his death, Edwin Howard Armstrong had finally won.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Long after he was gone, Armstrong was honored by the International Telecommunication Union. There, among his peers, his name is forever enshrined alongside those of André-Marie Ampère, Alexander Graham Bell, Michael Faraday, and Guglielmo Marconi.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Edwin Howard Armstrong’s discoveries formed the basis of communications technology for many decades to come. In fact, his FM ")]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("broadcast system was later used by another pioneer who bore the Armstrong name, though the two were related only in spirit.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1968, in a moment that would have delighted one of the twentieth century’s greatest unsung inventors, Neil Armstrong spoke to the world via FM radio from his station on the surface of the moon—the very place that Lee de Forest believed mankind would never visit.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5415ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 78
// module chunks = 0